import React, { useState } from "react";
import { Accordion, Row, Col, Button, Card } from "react-bootstrap";
import { Input } from "../../../../../library/input";
import { Label } from "../../../../../library/label";

const Index = ({ channelConfiguration, setChannelConfiguration }) => {
  const [activeTab, setActiveTab] = useState("0");

  return (
    <div className="email-configuration-container">
      <p>
        For å opprette en ny kanal må en administrator ha lagt inn en
        e-postadresse i "Innstillinger" under "Mitt foretak" fra menyen til
        venstre.
      </p>
      <Accordion
        className="email-config-accordion"
        defaultActiveKey="0"
        activeKey={activeTab}
      >
        <Card className="single-card top">
          <Card.Header className="card-header">
            <Accordion.Toggle
              className="card-toggle"
              as={Button}
              variant="link"
              eventKey="0"
              onClick={() => setActiveTab("0")}
            >
              Konfigurasjon <i class="fad fa-chevron-down"></i>
            </Accordion.Toggle>
          </Card.Header>
          <Accordion.Collapse eventKey="0">
            <Card.Body className="card-body">
              <Row className="info-row">
                <Col className="info-col">
                  <Label version={1} weight="bold">
                    Navn *
                  </Label>
                  <Input
                    value={
                      channelConfiguration && channelConfiguration.name
                        ? channelConfiguration.name
                        : null
                    }
                    onChange={(e) =>
                      setChannelConfiguration({
                        ...channelConfiguration,
                        name: e.target.value,
                      })
                    }
                    placeholder="Navn"
                    type="text"
                  />
                  <small>Må være lenger enn 3 karakterer.</small>
                </Col>
              </Row>
            </Card.Body>
          </Accordion.Collapse>
        </Card>
      </Accordion>
    </div>
  );
};

export default Index;
